import React from 'react';
import { Link } from 'wouter';
import { FileText, Loader2, ArrowLeft } from 'lucide-react';
import { useAppAuth } from '@/components/AuthProvider';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import { LectureDownloader } from '@/components/LectureDownloader';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import Slideshow, { SlideContent } from '@/components/lectures/Slideshow';

export default function AnatomyOfALongevityConsult() {
  const { isMentorshipMember, isLoading } = useAppAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }

  const isMentorshipUser = isMentorshipMember;

  if (!isMentorshipUser) {
    return (
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <div className="container mx-auto px-4 py-10 flex-grow flex items-center justify-center">
          <div className="bg-white border rounded-lg shadow-lg p-8 max-w-2xl w-full text-center">
            <div className="mx-auto w-16 h-16 bg-amber-100 flex items-center justify-center rounded-full mb-6">
              <FileText className="h-8 w-8 text-amber-600" />
            </div>
            <h1 className="text-3xl font-serif font-bold text-[#2C3E50] mb-4">Premium Content Access</h1>
            <p className="text-lg text-[#7F8C8D] mb-6">
              This lecture is available exclusively to Next Generation Medicine mentorship members.
              Join our mentorship program to access this and other expert-led educational content.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link href="/login?from=/mentorship/lectures/anatomy-of-a-longevity-consult">
                <Button variant="outline" className="w-full sm:w-auto">Sign In</Button>
              </Link>
              <Link href="/membership">
                <Button className="w-full sm:w-auto bg-gradient-to-r from-blue-600 to-indigo-600">View Membership Options</Button>
              </Link>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  const slides: SlideContent[] = [
    {
      id: 1,
      title: 'Overview',
      content: <p className="text-gray-700">This lecture is under development.</p>,
    },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <div className="container mx-auto px-4 py-8 flex-grow max-w-5xl">
        <Breadcrumb className="mb-6">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink href="/mentorship">Mentorship</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink href="/mentorship/lectures">Lectures</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink>Anatomy of a Longevity Consult</BreadcrumbLink>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <div className="flex items-center justify-between mb-6">
          <Link href="/mentorship" className="inline-flex items-center text-blue-600 hover:text-blue-800">
            <ArrowLeft className="w-4 h-4 mr-1" />
            Back to Mentorship Program
          </Link>
          <LectureDownloader lectureName="Anatomy Of A Longevity Consult" fileName="AnatomyOfALongevityConsult" />
        </div>

        <Tabs defaultValue="slideshow">
          <TabsList className="mb-4">
            <TabsTrigger value="slideshow">Slideshow</TabsTrigger>
          </TabsList>
          <TabsContent value="slideshow">
            <Slideshow slides={slides} />
          </TabsContent>
        </Tabs>
      </div>
      <Footer />
    </div>
  );
}
